var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
import { h } from "vue";
import { SmartRenderer, resolveVNode, styleNumberValueWithUnit } from "../../../lib/utils.js";
import get from "../../../node_modules/.pnpm/lodash-es@4.17.21/node_modules/lodash-es/get.js";
function createColumns(args) {
  const { columnHelper, columns = [], slots, sortingValueRef } = args, vueTableColumns = [], sortingValue = [];
  for (const column of columns) {
    const accessor = Array.isArray(column.dataIndex) ? column.dataIndex.join(",") : column.dataIndex ?? column.key, c = columnHelper.accessor(accessor, {
      header: /* @__PURE__ */ __name(() => h(SmartRenderer, { children: resolveVNode(column.title) }), "header"),
      cell: /* @__PURE__ */ __name((props) => {
        var _a;
        const value = column.dataIndex ? get(props.row.original, column.dataIndex) : void 0;
        return column.renderSlot && slots ? (_a = slots[column.renderSlot]) == null ? void 0 : _a.call(slots, {
          value,
          record: props.row.original,
          index: props.row.index
        }) : column.render ? column.render(value.value, props.row.original, props.row.index) : value;
      }, "cell"),
      meta: { ...column }
    });
    (column.sortOrder === "asc" || column.sortOrder === "desc") && sortingValue.push({ id: accessor, desc: column.sortOrder === "desc" }), vueTableColumns.push(c);
  }
  return sortingValueRef.value = sortingValue, vueTableColumns;
}
__name(createColumns, "createColumns");
function isUpdaterFunc(updater) {
  return typeof updater == "function";
}
__name(isUpdaterFunc, "isUpdaterFunc");
function updaterHelper(updater, r) {
  r.value = isUpdaterFunc(updater) ? updater(r.value) : updater;
}
__name(updaterHelper, "updaterHelper");
function object2array(obj) {
  const arr = [];
  if (!obj)
    return arr;
  for (const key in obj)
    obj[key] && arr.push(key);
  return arr;
}
__name(object2array, "object2array");
function array2object(arr) {
  const obj = {};
  return arr && arr.forEach((v) => obj[v] = !0), obj;
}
__name(array2object, "array2object");
function tableHeadStyle(width) {
  if (width)
    return { width: styleNumberValueWithUnit(width) };
}
__name(tableHeadStyle, "tableHeadStyle");
function parseWidth(width) {
  if (typeof width == "number")
    return { value: width, unit: "px" };
  const pxMatch = width.match(/^(\d+(?:\.\d+)?)px$/);
  return pxMatch ? {
    value: Number(pxMatch[1]),
    unit: pxMatch[2]
  } : { value: 0, unit: "px" };
}
__name(parseWidth, "parseWidth");
function buildCssLength(tokens) {
  if (tokens.length === 0)
    return "0";
  const unitMap = /* @__PURE__ */ new Map();
  for (const { unit, value } of tokens)
    unitMap.set(unit, (unitMap.get(unit) ?? 0) + value);
  const parts = [];
  for (const [unit, value] of unitMap)
    value !== 0 && parts.push(`${value}${unit}`);
  return parts.length === 0 ? "0" : parts.length === 1 ? parts[0] : `calc(${parts.join("+")})`;
}
__name(buildCssLength, "buildCssLength");
function computeStickyOffsets(columns, expandable, rowSelection) {
  const result = {}, startTokens = [];
  (expandable == null ? void 0 : expandable.fixed) === "start" && (expandable != null && expandable.columnWidth) && (result.rowExpandable = buildCssLength(startTokens), startTokens.push(parseWidth(expandable.columnWidth)), result.startBoundary = "rowExpandable"), (rowSelection == null ? void 0 : rowSelection.fixed) === "start" && rowSelection.columnWidth && (result.rowSelection = buildCssLength(startTokens), startTokens.push(parseWidth(rowSelection.columnWidth)), result.startBoundary = "rowSelection"), columns.forEach((col, index) => {
    col.fixed === "start" && col.width && (result[index] = buildCssLength(startTokens), startTokens.push(parseWidth(col.width)), result.startBoundary = index);
  });
  const endTokens = [];
  for (let i = columns.length - 1; i >= 0; i--) {
    const col = columns[i];
    col.fixed === "end" && col.width && (result[i] = buildCssLength(endTokens), endTokens.push(parseWidth(col.width)), result.endBoundary = i);
  }
  return (rowSelection == null ? void 0 : rowSelection.fixed) === "end" && rowSelection.columnWidth && (result.rowSelection = buildCssLength(endTokens), endTokens.push(parseWidth(rowSelection.columnWidth)), result.endBoundary = "rowSelection"), (expandable == null ? void 0 : expandable.fixed) === "end" && expandable.columnWidth && (result.rowExpandable = buildCssLength(endTokens), endTokens.push(parseWidth(expandable.columnWidth)), result.endBoundary = "rowExpandable"), result;
}
__name(computeStickyOffsets, "computeStickyOffsets");
function stickyStyle(fixedType, value, scrollbarWidth) {
  if (fixedType && value) {
    let stickyValue = value;
    return fixedType === "end" && scrollbarWidth && (value === "0" ? stickyValue = `${scrollbarWidth}px` : stickyValue = `calc(${value} + ${scrollbarWidth}px)`), `--eci-saas-ui-table-wrapper-sticky-${fixedType}:${stickyValue}`;
  }
}
__name(stickyStyle, "stickyStyle");
export {
  array2object,
  computeStickyOffsets,
  createColumns,
  object2array,
  stickyStyle,
  tableHeadStyle,
  updaterHelper
};
//# sourceMappingURL=utils.js.map
